/* This file contains some code to format a number into a String.*/
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
    var isInfinity = !isFinite(number);
    var isZero = false;
    var numStr = Math.abs(number) + '',
        formattedText = '',
        parsedNumber;

    if (isInfinity) {
        formattedText = '\u221e';
    } else {
        parsedNumber = parse(numStr);

        roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

        var digits = parsedNumber.d;
        var integerLen = parsedNumber.i;
        var exponent = parsedNumber.e;
        var decimals = [];
        isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

        // pad zeros for small numbers
        while (integerLen < 0) {
            digits.unshift(0);
            integerLen++;
        }

        // extract decimals digits
        if (integerLen > 0) {
            decimals = digits.splice(integerLen);
        } else {
            decimals = digits;
            digits = [0];
        }

        // format the integer digits with grouping separators
        var groups = [];
        if (digits.length > pattern.lgSize) {
            groups.unshift(digits.splice(-pattern.lgSize).join(''));
        }
        while (digits.length > pattern.gSize) {
            groups.unshift(digits.splice(-pattern.gSize).join(''));
        }
        if (digits.length) {
            groups.unshift(digits.join(''));
        }
        formattedText = groups.join(groupSep);

        // append the decimal digits
        if (decimals.length) {
            formattedText += decimalSep + decimals.join('');
        }

        if (exponent) {
            formattedText += 'e+' + exponent;
        }
    }
    if (number < 0 && !isZero) {
        return pattern.negPre + formattedText + pattern.negSuf;
    } else {
        return pattern.posPre + formattedText + pattern.posSuf;
    }
}

function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
        digits.splice(roundAt);
    } else {
        // We rounded to zero so reset the parsedNumber
        parsedNumber.i = 1;
        digits.length = roundAt = fractionSize + 1;
        for (var i=0; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) digits[roundAt - 1]++;

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < fractionSize; fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
        d = d + carry;
        digits[i] = d % 10;
        return Math.floor(d / 10);
    }, 0);
    if (carry) {
        digits.unshift(carry);
        parsedNumber.i++;
    }
}
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';
var MAX_DIGITS = 22;
function parse(numStr) {
    var exponent = 0, digits, numberOfIntegerDigits;
    var i, j, zeros;

    // Decimal point?
    if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
        numStr = numStr.replace(DECIMAL_SEP, '');
    }

    // Exponential form?
    if ((i = numStr.search(/e/i)) > 0) {
        // Work out the exponent.
        if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
        numberOfIntegerDigits += +numStr.slice(i + 1);
        numStr = numStr.substring(0, i);
    } else if (numberOfIntegerDigits < 0) {
        // There was no decimal point or exponent so it is an integer.
        numberOfIntegerDigits = numStr.length;
    }

    // Count the number of leading zeros.
    for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++);

    if (i == (zeros = numStr.length)) {
        // The digits are all zero.
        digits = [0];
        numberOfIntegerDigits = 1;
    } else {
        // Count the number of trailing zeros
        zeros--;
        while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;

        // Trailing zeros are insignificant so ignore them
        numberOfIntegerDigits -= i;
        digits = [];
        // Convert string to array of digits without leading/trailing zeros.
        for (j = 0; i <= zeros; i++, j++) {
            digits[j] = +numStr.charAt(i);
        }
    }

    // If the number overflows the maximum allowed digits then use an exponent.
    if (numberOfIntegerDigits > MAX_DIGITS) {
        digits = digits.splice(0, MAX_DIGITS - 1);
        exponent = numberOfIntegerDigits - 1;
        numberOfIntegerDigits = 1;
    }

    return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Creates a validator function for validating numeric strings, there string should contain only numeric values.
 * @param ctrl controller to use
 * @returns {Function} validator function.
 */
function createNumericStringValidator(ctrl) {
    return function(ngModelValue) {

        if(/^[0-9]*$/.test(ngModelValue)) {
            ctrl.$setValidity('numberValidator', true);
        }
        else {
            ctrl.$setValidity('numberValidator', false);
        }

        return ngModelValue;
    };
}

/**
 * Checks whether the given value is undefined
 * @param value value to check
 * @returns {boolean} true when undefined
 */
function isUndefined(value) {return typeof value === 'undefined';}

/**
 * Converts url to valid url with replaced empty space to %20.
 * @param val value to convert
 * @returns {*} converted value
 */
function toUrlWithoutWhitespace(val) {
    //We can not use encode
    if(val && typeof val == 'string') {

        return val.replace(/ /g, '%20')
    }

    return val;
}